
import { login } from '@/service/index'
import Alert from 'vux/src/components/alert/index.vue'

import { go } from '@/util/router'
import { isNullOrEmpty } from '@/util/util'
import { getItem, setToken } from '@/util/jwtAuth'
import { jwtSecret } from '@/config/env'
let jwt = require('jwt-simple')
export default {
name: 'login',
data () {
return {
title: '温馨提示：',
alertShow: false,
content: '',
LoginModel: {UserName: '', PWD: ''}
}
},
components: {
Alert
},
created () {
let user = localStorage.getItem('user')
if (user) {
user = jwt.decode(user, jwtSecret)
this.LoginModel.UserName = unescape(user.name)
this.LoginModel.PWD = user.pwd
}
},
mounted () {

},
watch: {
'$route': function (to, from) {

}
},
methods: {
Modify () {
go('/modify')
},
doSubmit () {
let vm = this
if (!isNullOrEmpty(vm.LoginModel.UserName)) {
vm.alertShow = true
vm.content = '请输入用户名!'
return
}
if (!isNullOrEmpty(vm.LoginModel.PWD)) {
vm.alertShow = true
vm.content = '请输入密码!'
return
}
console.log(vm.LoginModel)
login(vm.LoginModel, (res) => {
console.log(res)
if (res.code === '1') {
let user = {
uid: res.data,
name: vm.LoginModel.UserName,
pwd: vm.LoginModel.PWD
}
localStorage.setItem('user',jwt.encode(user, jwtSecret))
setToken(user)
let redirect = this.$route.query.redirect
if(redirect){
go(redirect)
}else{
go('/home1')
}

} else {
vm.showToast(res.msg)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/page/login/login.vue